import { firstRunCopy } from '@/copy'
import { Button } from '@/ui/Button/Button'
import { EmptyState } from '@/ui/EmptyState/EmptyState'
import { Container } from '@/ui/layout/Container'
import { ROUTES } from '../constants/routes'
import { useWorkspaceStore } from '../store/workspace'
import styles from './HomePage.module.css'

export function HomePage() {
  const activeWorkspaceId = useWorkspaceStore((s) => s.activeWorkspaceId)
  const workspaces = useWorkspaceStore((s) => s.workspaces)

  return (
    <div className={styles.home}>
      <Container size="container-form">
        {workspaces.length === 0 ? (
          <EmptyState
            titleAs="h1"
            title={firstRunCopy.home.noWorkspace}
            description={firstRunCopy.home.noWorkspaceDescription}
            action={
              <Button href={ROUTES.workspaceNew}>
                {firstRunCopy.home.newWorkspace}
              </Button>
            }
          />
        ) : (
          <EmptyState
            titleAs="h1"
            title={firstRunCopy.home.noTopic}
            description={firstRunCopy.home.noTopicDescription}
            action={
              activeWorkspaceId ? (
                <Button href={ROUTES.topicNew(activeWorkspaceId)}>
                  {firstRunCopy.home.newTopic}
                </Button>
              ) : undefined
            }
          />
        )}
      </Container>
    </div>
  )
}
